var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "b-container",
    { attrs: { fluid: "" } },
    [
      _c(
        "b-row",
        [
          _c(
            "b-col",
            [
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    [
                      _c(
                        "b-form-group",
                        {
                          staticClass: "mb-2",
                          attrs: {
                            label:
                              _vm.$t("apeironGwApp.lieSnp.form.nombreDeLaLie") +
                              " *",
                            "label-for": "input-nombre-linea",
                          },
                        },
                        [
                          _c("b-form-input", {
                            attrs: {
                              id: "input-nombre-linea",
                              placeholder: _vm.$t(
                                "apeironGwApp.lieSnp.form.nombreDeLaLie"
                              ),
                              disabled: !_vm.esEscritura,
                              state: !_vm.$v.lieForm.nombreDeLinea.$invalid,
                            },
                            model: {
                              value: _vm.lieForm.nombreDeLinea,
                              callback: function ($$v) {
                                _vm.$set(_vm.lieForm, "nombreDeLinea", $$v)
                              },
                              expression: "lieForm.nombreDeLinea",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    [
                      _c(
                        "b-form-group",
                        {
                          staticClass: "mb-2",
                          attrs: {
                            label:
                              _vm.$t("apeironGwApp.lieSnp.form.clasificacion") +
                              " *",
                            "label-for": "input-clasificacion",
                          },
                        },
                        [
                          _c("b-form-select", {
                            attrs: {
                              id: "input-clasificacion",
                              options: _vm.clasificaciones,
                              placeholder: _vm.$t(
                                "apeironGwApp.lieSnp.form.clasificacion"
                              ),
                              disabled: !_vm.esEscritura,
                              state: !_vm.$v.lieForm.clasificacion.$invalid,
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "first",
                                fn: function () {
                                  return [
                                    _c(
                                      "b-form-select-option",
                                      { attrs: { value: null, disabled: "" } },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm
                                              .$t(
                                                "apeironGwApp.lieSnp.form.seleccionarUno"
                                              )
                                              .toString()
                                          )
                                        ),
                                      ]
                                    ),
                                  ]
                                },
                                proxy: true,
                              },
                            ]),
                            model: {
                              value: _vm.lieForm.clasificacion,
                              callback: function ($$v) {
                                _vm.$set(_vm.lieForm, "clasificacion", $$v)
                              },
                              expression: "lieForm.clasificacion",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    [
                      _c(
                        "b-form-group",
                        {
                          staticClass: "mb-2",
                          attrs: {
                            label:
                              _vm.$t("apeironGwApp.lieSnp.form.fechaAlta") +
                              " *",
                            "label-for": "input-fecha-alta",
                          },
                        },
                        [
                          _c("b-form-datepicker", {
                            attrs: {
                              id: "input-fecha-alta",
                              placeholder: _vm.$t(
                                "apeironGwApp.lieSnp.form.fechaAlta"
                              ),
                              disabled: !_vm.esEscritura,
                              state: !_vm.$v.lieForm.fechaAlta.$invalid,
                              max: _vm.fechaHoy,
                            },
                            model: {
                              value: _vm.lieForm.fechaAlta,
                              callback: function ($$v) {
                                _vm.$set(_vm.lieForm, "fechaAlta", $$v)
                              },
                              expression: "lieForm.fechaAlta",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    [
                      _c(
                        "b-form-group",
                        {
                          staticClass: "mb-2",
                          attrs: {
                            label:
                              _vm.$t(
                                "apeironGwApp.lieSnp.form.temasIncidenciaNacional"
                              ) + " *",
                            "label-for": "input-temas-incidencia-nacional",
                          },
                        },
                        [
                          _c("seleccion-tablas", {
                            attrs: {
                              disabled: !_vm.esEscritura,
                              state:
                                !_vm.$v.lieForm.temasPrioritariosPeciti
                                  .$invalid,
                              opciones: _vm.temasIncidenciaNacional,
                              keyComp: _vm.comparacionTemasIncidenciaNacional,
                              inicial: _vm.inicialTemasIncidenciaNacional,
                            },
                            on: {
                              "change-selection": function ($event) {
                                _vm.lieForm.temasPrioritariosPeciti = $event
                              },
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    [
                      _c(
                        "b-form-group",
                        {
                          staticClass: "mb-2",
                          attrs: {
                            label:
                              _vm.$t(
                                "apeironGwApp.lieSnp.form.institucionSede"
                              ) + " *",
                            "label-for": "input-sede",
                          },
                        },
                        [
                          _c("b-form-checkbox-group", {
                            attrs: {
                              id: "input-sedes",
                              options: _vm.instituciones,
                              stacked: "",
                            },
                            model: {
                              value: _vm.lieForm.instituciones,
                              callback: function ($$v) {
                                _vm.$set(_vm.lieForm, "instituciones", $$v)
                              },
                              expression: "lieForm.instituciones",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-alert",
                        {
                          attrs: {
                            variant: "warning",
                            show: _vm.instituciones.length < 1,
                          },
                        },
                        [
                          _c("span", {
                            domProps: {
                              textContent: _vm._s(
                                _vm.$t(
                                  "apeironGwApp.lieSnp.mensajes.seleccionarPrograma"
                                )
                              ),
                            },
                          }),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    [
                      _c(
                        "b-form-group",
                        {
                          staticClass: "mb-2",
                          attrs: {
                            label:
                              _vm.$t("apeironGwApp.lieSnp.form.justificacion") +
                              " *",
                            "label-for": "input-justificacion",
                          },
                        },
                        [
                          _c("b-form-textarea", {
                            attrs: {
                              id: "input-justificacion",
                              placeholder: _vm.$t(
                                "apeironGwApp.lieSnp.form.justificacion"
                              ),
                              disabled: !_vm.esEscritura,
                              state: !_vm.$v.lieForm.justificacion.$invalid,
                            },
                            model: {
                              value: _vm.lieForm.justificacion,
                              callback: function ($$v) {
                                _vm.$set(_vm.lieForm, "justificacion", $$v)
                              },
                              expression: "lieForm.justificacion",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c("b-row", [_c("b-col", [_c("hr")])], 1),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { staticStyle: { "text-align": "end" } },
                    [
                      _vm.esEscritura
                        ? _c(
                            "b-button",
                            {
                              attrs: {
                                type: "button",
                                variant: "primary",
                                disabled: _vm.formularioIsInvalid,
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.guardarLie()
                                },
                              },
                            },
                            [
                              _c("span", {
                                domProps: {
                                  textContent: _vm._s(
                                    _vm.$t("apeironGwApp.lieSnp.acciones.add")
                                  ),
                                },
                              }),
                              _vm._v(" "),
                              _c("font-awesome-icon", {
                                staticClass: "mr-2",
                                attrs: { icon: "add" },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "b-button",
                        {
                          attrs: { type: "button", variant: "secondary" },
                          on: {
                            click: function ($event) {
                              return _vm.limpiarDatos()
                            },
                          },
                        },
                        [
                          _c("span", {
                            domProps: {
                              textContent: _vm._s(
                                _vm.$t("apeironGwApp.lieSnp.acciones.limpiar")
                              ),
                            },
                          }),
                          _vm._v(" "),
                          _c("font-awesome-icon", {
                            staticClass: "mr-2",
                            attrs: { icon: "refresh" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }